import React, { useEffect, useMemo, useState } from 'react';
import SEOHelmet from '../components/SEOHelmet';

export const ambassadors = [
  { id: 1, name: 'Ben Fraj Roua', sb: 'Enicarthage', image: '/ambassadors/01-Ben Fraj Roua.jpg' },
  { id: 2, name: 'Hanin Rezgui', sb: 'FSB', image: '/ambassadors/02-Hanin rezgui.jpg' },
  { id: 3, name: 'Ons Akremi', sb: 'Esprit', image: '/ambassadors/03-Ons Akremi.jpg' },
  { id: 4, name: 'Lamouri Houssem', sb: 'ISET Rades', image: '/ambassadors/04-Lamouri Houssem.jpg' },
  { id: 5, name: 'Annabi Aziz', sb: 'isetcom', image: '/ambassadors/05-annabi aziz.jpg' },
  { id: 6, name: 'Ahmed Zaouga', sb: 'Issatm', image: '/ambassadors/06-Ahmed zaouga.jpg' },
  { id: 7, name: 'Wiem Homrani', sb: 'FST', image: '/ambassadors/07-Wiem homrani.jpg' },
  { id: 8, name: 'Eya Mezgar', sb: 'TBS', image: '/ambassadors/08-Eya Mezgar.jpg' },
  { id: 9, name: 'Nour Elyakin Nakkai', sb: 'ISET NABEUL', image: '/ambassadors/09-Nour Elyakin Nakkai.jpg' },
  { id: 10, name: 'Yahya Ben Mohamed', sb: 'ISTIC', image: '/ambassadors/10-Yahya Ben Mohamed.jpg' },
  { id: 11, name: 'Shimi Maram', sb: 'ISET Kairaoun', image: '/ambassadors/11-Shimi Maram.jpg' },
  { id: 12, name: 'Chaieb Ilyes', sb: 'Sesame university', image: '/ambassadors/12-Chaieb ilyes.jpg', objectPosition: 'center 22%' },
  { id: 13, name: 'Maryem Ben Yedem', sb: 'ISET ZAGHOUAN', image: '/ambassadors/13-Maryem ben yedem.jpg' },
  { id: 14, name: 'Ranim Mahdi', sb: 'FSB', image: '/ambassadors/14-ranim mahdi.jpg' },
  { id: 15, name: 'Dridi Selim', sb: 'Essths', image: '/ambassadors/15-Dridi Selim.jpg' },
  { id: 16, name: 'Jenzri Med Aziz', sb: 'EPI SOUSSE', image: '/ambassadors/16-Jenzri Med Aziz.jpg' },
  { id: 17, name: 'Souha Benzarti', sb: 'EPI Digital', image: '/ambassadors/17-souha benzarti.jpg' },
  { id: 18, name: 'Yesmine Boukrayaa', sb: 'ISET Sousse', image: '/ambassadors/18-Yesmine Boukrayaa.jpg' },
  { id: 19, name: 'Zeineb Jomni', sb: 'Enig', image: '/ambassadors/19-Zeineb Jomni.jpg' },
  { id: 20, name: 'Nassim Zorai', sb: 'Enit', image: '/ambassadors/20-Nassim zorai.jpg' }
];

function Ambassadors() {
  const getCardsPerView = () => {
    if (typeof window === 'undefined') return 4;
    if (window.innerWidth <= 520) return 1;
    if (window.innerWidth <= 900) return 2;
    return 4;
  };

  const [cardsPerView, setCardsPerView] = useState(getCardsPerView);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isSliding, setIsSliding] = useState(false);

  const goToIndex = (nextIndex) => {
    setIsSliding(true);
    setCurrentIndex(nextIndex);
  };

  const handlePointerEnter = (event) => {
    if (event.pointerType === 'mouse') {
      setIsPaused(true);
    }
  };

  const handlePointerLeave = (event) => {
    if (event.pointerType === 'mouse') {
      setIsPaused(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setCardsPerView(getCardsPerView());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = useMemo(
    () => Math.max(ambassadors.length - cardsPerView, 0),
    [cardsPerView]
  );

  useEffect(() => {
    setCurrentIndex((prev) => Math.min(prev, maxIndex));
  }, [cardsPerView, maxIndex]);

  useEffect(() => {
    if (isPaused || ambassadors.length <= cardsPerView) return undefined;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = prev >= maxIndex ? 0 : prev + 1;
        setIsSliding(true);
        return next;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused, cardsPerView, maxIndex]);

  useEffect(() => {
    if (!isSliding) return undefined;
    const timeout = setTimeout(() => setIsSliding(false), 280);
    return () => clearTimeout(timeout);
  }, [isSliding]);

  return (
    <div>
      <SEOHelmet 
        title="Ambassadors - Code It Up 6.0 Hackathon"
        description="Meet the ambassadors of Code It Up 6.0 from various universities. These passionate individuals are spreading awareness about our hackathon across their institutions."
        keywords="ambassadors, code it up ambassadors, hackathon ambassadors, university ambassadors"
        canonical="https://code-it-up-6.netlify.app/ambassadors"
      />
      <h1 style={{ textAlign: 'center' }}>OUR AMBASSADORS</h1>
      <p className="section-subtitle">The brave souls spreading the word across Bikini Bottom!</p>

      <div
        className="ambassadors-slider"
        style={{ '--cards-per-view': cardsPerView }}
        onPointerEnter={handlePointerEnter}
        onPointerLeave={handlePointerLeave}
        onPointerDown={() => setIsPaused(false)}
      >
        <div
          className={`ambassadors-track ${isSliding ? 'is-sliding' : ''}`}
          style={{ transform: `translateX(-${(currentIndex * 100) / cardsPerView}%)` }}
        >
          {ambassadors.map((amb) => (
            <div key={amb.id} className="ambassador-slide-item">
              <article className="ambassador-card">
                <div className="ambassador-avatar">
                  <img
                    src={amb.image}
                    alt={`${amb.name} ambassador`}
                    className="ambassador-avatar-image"
                    loading="lazy"
                    style={amb.objectPosition ? { objectPosition: amb.objectPosition } : undefined}
                  />
                </div>

                <div className="ambassador-content">
                  <h3>{amb.name}</h3>
                  <p className="ambassador-role">Ambassador</p>
                  <p className="ambassador-sb">{amb.sb}</p>
                </div>
              </article>
            </div>
          ))}
        </div>

        {maxIndex > 0 && (
          <div className="ambassadors-slider-dots" aria-label="Ambassadors slider pagination">
            {Array.from({ length: maxIndex + 1 }).map((_, index) => (
              <button
                key={index}
                type="button"
                className={`ambassadors-slider-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToIndex(index)}
                aria-label={`Go to ambassador slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Ambassadors;
